// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"38":"2d3e73352f7a0536","490":"8b9443479692fbbc","2639":"8089236dd84de2a3","9129":"2ac702a5cef895f1"}[chunkId] + ".css";
};